<div class="exception-body notfound">
    <div class="particle elem1 anim-delay1"></div>
    <div class="particle elem2 anim-delay5"></div>
    <div class="particle elem3 anim-delay3"></div>
    <div class="particle elem4 anim-delay8"></div>
    <div class="particle elem5 anim-delay9"></div>
    <div class="particle elem6 anim-delay2"></div>
    <div class="particle elem7 anim-delay4"></div>
    <div class="exception-panel">
        <div class="exception-panel-content">
            <div class="information-text">
                <h1 class="title">404</h1>
                <span><strong>Página no encontrada.</strong></span>
            </div>
        </div>
    </div>
</div>